import { apiClient } from "../client";
import type { ActivePlansResponse } from "@/types/profile";

export const planService = {
  getActivePlans: async (): Promise<ActivePlansResponse> => {
    try {
      // Already narrowed to the currencies the caller's business may buy.
      const { data } = await apiClient.get(`/plans/available`);
      return data;
    } catch (error: any) {
      // A backend that predates /plans/available answers 404; the full catalog keeps
      // the plan picker working while web and API are deployed one after the other.
      if (error?.response?.status === 404) {
        const { data } = await apiClient.get(`/plans/active`);
        return data;
      }
      console.error("Error fetching active plans:", error);
      throw error;
    }
  },
};
